<template>
    <div>
        <!-- Hero Banner -->
        <HeroBanner />
        
        <!-- About Us Section -->
        <AboutUs />

                
        <!-- Move Text Wrapper -->
        <MoveTextWrapper />
        
        <!-- Home Services Section -->
        <HomeServices />
        
        <!-- Blog Section -->
        <Blog />
    </div>
</template>

<script>
import HeroBanner from '@/components/Home/HeroBanner.vue'
import MoveTextWrapper from '@/components/Home/MoveTextWrapper.vue'
import AboutUs from '@/components/Home/AboutUs.vue'
import HomeServices from '@/components/Home/HomeServices.vue'
import Blog from '@/components/Home/Blog.vue'
import ContactSection from '@/components/Home/ContactSection.vue'

export default {
    name: 'Home',
    components: {
        HeroBanner,
        MoveTextWrapper,
        AboutUs,
        HomeServices,
        Blog,
        ContactSection
    },
    mounted() {
    }
}
</script>

